<template>
    <div> 
        <div>
            <div v-if="ashow">
                <ul  class="zhibo"  v-for="item in list" :key="item.title"  @click="infobtn(item)">
                    <li>
                        <span>
                            <img src="@/assets/yuwen.png" alt="">
                            <p>{{item.name}}</p>
                        </span>
                        <span>开课时间：{{item.classtime_begin}}</span>
                        <div class="clear">
                            <span class="fl">
                                <img :src="item.speaker_avatar" width="100%" alt="">
                                <p>{{item.speak_teacher}}</p>
                            </span>
                            <span class="fr"><span>原价:¥{{item.price}}</span> ¥{{item.sale_price}}</span>
                        </div>
                    </li>
                </ul>
            </div>   
            <div v-else class="zanwu">暂无课程</div>
        </div>
    </div>
</template>

<script>
import URL from '../api/index'
import VueEvent from '../model/VueEvent';

export default {
    data(){
        return{
            list:[],
            isshow:true,
            ashow:false,
            da:{
                grade_id:0,
                subgect_id:0,
                style:0
            },
            word:'',
        }
    },
    watch:{
            'da.grade_id':function(data){
                this.tab(this.da)           
            },
            'da.subgect_id':function(data){
                this.tab(this.da)
            },
            'da.style':function(data){
                this.tab(this.da)
            },
            'word':function(data){
                this.tab(this.da)
            },
    },    
    mounted(){
        var that = this
        VueEvent.$on('tab',function(data){
            that.da.style=data
        })
        VueEvent.$on('nianji',function(data){
            that.da.grade_id=data
            that.word = ""
        })  
        VueEvent.$on('kemu',function(data){
            that.da.subgect_id=data 
        }) 
        VueEvent.$on('word',function(data){
            that.word = data
        })     
        this.tab(this.da)
        this.$axios({
            method:'post',
            url:URL.course,
            data:{
                grade:0,
                subject:0,
                style:1,
                
            }
        }).then((res)=>{
            if(res.data.result.page_total==0){
                that.ashow=false
            }else{
                that.ashow=true
            }
            that.list = res.data.result.course
            console.log(that.list);   
            if(that.$route.path=="/"){
                that.list = res.data.result.course.splice(0,4)
            }
        })
    },
    methods:{
        infobtn(item){
            this.$router.push({
                name:'zhiboxq',
                query:{
                    cid: item.cid,
                    livetype : item.livetype,
                    type: item.type
                }
            })
        },
        live(){
            this.$router.push('/live')
        },
        tab(dad){
            var that=this
            this.$axios({
                method:'post',
                url:URL.course,
                data:{
                    grade:dad.grade_id,
                    subject:dad.subgect_id,
                    style:dad.style,
                    word: that.word
                }
            }).then((res)=>{
                    if(res.data.result.page_total==0){
                    that.ashow=false
                }else{
                    that.ashow=true
                }
                console.log(res);  
                that.list = res.data.result.course
                // console.log(that.list);   

            })
        }
    }
}
</script>

<style scoped>
.zhibo{
    padding: 0 15px;
}
.zhibo li{
    padding: 8px;
    box-shadow: 0 0 5px #ddd;
    margin-bottom: 20px;
}
.zhibo li span:first-child{
    line-height: 24px;
}
.zhibo li span:first-child img{
    display: inline-block;
    vertical-align: middle;
    width: 40px;
}
.zhibo li span:first-child p{
    display: inline-block;
    color: #2a2a2a;
    font-size: 16px;
    font-weight: 700;
    vertical-align: middle;
}
.zhibo li span:nth-child(2){
    display: block;
    line-height: 30px;
    font-size: 12px;
    color: #6e7578;
}
.zhibo li div span:first-child img{
    width: 28px;
    height: 28px;
    border-radius: 50%;
}
.zhibo li div span:first-child p{
    font-size: 14px;
    font-weight: normal;
}
.zhibo li div span:nth-child(2){
    color: #f41521;
    font-size: 18px;
    text-decoration: none;
    margin-top: 0;
    display: inline-block;
}
.zhibo li div span:nth-child(2) span{
    font-size: 12px;
    color: #6e7578;
    text-decoration: line-through; 
}
</style>



// WEBPACK FOOTER //
// src/components/CourseZhibo.vue